import { useTranslation } from 'react-i18next';
import ErrorBoundary from 'src/components/ErrorBoundary';
import Navbar from 'src/components/NavBar';
import useWindowSize from 'src/hooks/useWindowSize';
import AdminToolsHeader from 'src/sections/edi_admin_tools/AdminToolsHeader';
import { EdiAdminContextProvider } from 'src/sections/edi_admin_tools/EdiAdminContext';
import ToggleEdiAdminView from 'src/sections/edi_admin_tools/ToggleEdiAdminView';

const EdiAdminTools = () => {
  const { t } = useTranslation();
  const { height } = useWindowSize();

  return (
    <ErrorBoundary>
      <EdiAdminContextProvider>
        <div
          style={{
            display: 'grid',
            height: `${height}px`,
            gridTemplateRows: 'auto 1fr',
            gridTemplateColumns: '1fr',
            overflow: 'auto',
            gridTemplateAreas: `
          "navbar"
          "main"
        `,
          }}
        >
          <div className="bg-white pb-2 mb-2 grid-area-navbar self-start">
            <Navbar title={t('EDI Admin Tools')} />
            <AdminToolsHeader />
          </div>
          <ToggleEdiAdminView />
        </div>
      </EdiAdminContextProvider>
    </ErrorBoundary>
  );
};

export default EdiAdminTools;
